






















































import { cloneDeep, isEqual } from 'lodash-es';
import { computed, defineComponent, toRefs, PropType, ref, onMounted, watch } from '@vue/composition-api';
import { logger } from '@tt4b/ttam-utils';
import { useSaveVideoToLibraryApi, useVideoUploader, useGetVideoInfoApi } from '@tt4b/ttam-hooks';
import {
  AdgroupFormData,
  FileUploadStatus,
  FullNormalFormData,
  MaterialType,
  VideoMaterial,
  VideoToUpload,
} from '@tt4b/ttam-enums';

import TtamMaterialUploadSelectTable from './select-table.vue';
import TtamMaterialUploadProgressTable from './progress-table.vue';
import { trackEvent } from './../../../../utils/index';

function after<A extends any[], R>(fn: (...args: A) => R, afterFn: () => void) {
  return function (...args: A): R {
    const result = fn.apply(this, args);
    if (result instanceof Promise) {
      return result.finally(res => {
        afterFn();
        return res;
      }) as R;
    } else {
      afterFn();
      return result;
    }
  };
}

const name = 'ttam-material-upload-table';

export default defineComponent({
  name,

  props: {
    limit: { type: Number, default: 1 },
    files: { type: Array as PropType<VideoToUpload[]>, default: () => [] },
    fileType: { type: String as PropType<MaterialType>, default: MaterialType.Video },
    isInventoryValidateVisible: { type: Boolean, default: true },
    aadvid: { type: String, default: '' },
    isAco: { type: Boolean, default: false },
    isSpc: { type: Boolean, default: false },
    adgroupData: { type: Object as PropType<AdgroupFormData>, default: () => ({}) },
    creativeData: { type: Object as PropType<FullNormalFormData>, default: () => ({}) },
  },

  components: {
    TtamMaterialUploadSelectTable,
    TtamMaterialUploadProgressTable,
  },

  setup(props, { emit }) {
    const selectTableNode = ref();
    const { files, aadvid, isAco, isSpc, adgroupData, creativeData } = toRefs(props);

    const selectedFileIds = ref<string[]>([]);
    const selectedFiles = computed(() => files.value.filter(item => selectedFileIds.value.includes(item.uid)));
    const selectedFilesCount = computed(() => selectedFileIds.value.length);

    const isTableVisible = computed(() => files.value.length);

    const isProgressTableVisible = computed(
      () =>
        isTableVisible.value &&
        files.value.every(item => item.uploaderStatus) &&
        files.value.some(item => item.uploaderStatus !== FileUploadStatus.Ready),
    );

    const isSelectTableVisible = computed(() => !isProgressTableVisible.value);

    function onSelect(items) {
      selectedFileIds.value = items.map(item => item.uid);
    }

    const uploadCompleteCount = ref(0);
    const uploadedFiles = ref([]);

    watch(uploadCompleteCount, () => {
      if (uploadCompleteCount.value === 0) {
        return;
      }

      if (uploadCompleteCount.value === selectedFilesCount.value) {
        logger.info('material table upload complete', uploadedFiles.value);
        emit('upload-complete', cloneDeep(uploadedFiles.value));
      }
    });

    /** 上传失败 */
    const onUploadFail = (beAnalysisResult, feAnalysisResult, errorInfo?) => {
      uploadCompleteCount.value += 1;
    };

    /** 上传成功 */
    const onUploadSuccess = after(
      async (newFile, preFile: VideoMaterial) => {
        const curFile = files.value.find(({ vid }) => vid === preFile.vid);
        if (!curFile || (preFile as any).uploaderStatus === FileUploadStatus.Fail) {
          // updatePageStatus();
          return;
        }
        Object.keys(preFile).forEach(key => {
          if (key && preFile[key] && !isEqual(curFile[key], preFile[key])) {
            curFile[key] = preFile[key] as never;
          }
        });
        curFile.uploaderStatus = FileUploadStatus.SavingToLibrary;
        emit('upload-complete', curFile.verify || []);
        if (curFile.cancel) {
          return;
        }
        const response = await useSaveVideoToLibraryApi({
          vid: newFile.vid,
          name: newFile.name ?? preFile.name,
          status: newFile.status,
          originalVid: newFile.vid === preFile.vid ? preFile.vid : undefined,
        });

        if (response) {
          const videoInfo = await useGetVideoInfoApi(newFile.vid);
          curFile.uploaderStatus = FileUploadStatus.Success;
          uploadedFiles.value.push({
            ...newFile,
            ...response,
            originUid: preFile.originUid,
            ...(videoInfo?.poster_url ? { coverUrl: videoInfo.poster_url } : {}),
          });
        } else {
          curFile.uploaderStatus = FileUploadStatus.Fail;
        }
      },
      () => {
        uploadCompleteCount.value += 1;
      },
    );

    /** 上传按钮事件 */
    async function onUpload() {
      uploadCompleteCount.value = 0;
      uploadedFiles.value = [];
      // pageStatus.value = VIDEO_UPLOAD_PAGE_STATUS.uploading;
      // files.value = selectedItems.value;
      // selectedItems.value = [];
      const { start } = await useVideoUploader({
        adgroupFormData: adgroupData,
        creativeFormData: creativeData,
        isAco,
        isSpc,
        userId: aadvid.value,
        fileArr: selectedFiles.value,
        isNeedPreCheckBeforeUpload: false,
        events: {
          onError: onUploadFail,
          onSuccess: onUploadSuccess,
        },
      });
      start();
      // 关闭抽屉
      // closeSideSlip();
      // 开始统计上传进度
      // ctx.emit('startUpload');
      // 统计上传的耗时
      // startDuration('uploadVideoNew');
      trackEvent('video_upload_at_video_invalid_user_choose_type', { choose_type: 'upload' });
    }

    function onCancel() {
      emit('close');
    }

    async function startUpload() {
      await onUpload();
      onCancel();
      emit('start-upload', selectedFiles);
    }

    onMounted(() => {
      selectTableNode?.value?.selectAll();
    });

    return {
      isTableVisible,
      isSelectTableVisible,
      isProgressTableVisible,
      selectTableNode,
      selectedFiles,
      selectedFileIds,
      selectedFilesCount,

      onSelect,
      onCancel,
      startUpload,
      onUploadSuccess,
    };
  },
});
